import PCIcon from "../assets/PC.svg";
import PlayStationIcon from "../assets/PlayStation.svg";
import XboxIcon from "../assets/Xbox.svg";
import NintendoIcon from "../assets/Nintendo.svg";
import iOSIcon from "../assets/iOS.svg";
import LinuxIcon from "../assets/Linux.svg";
import AndroidIcon from "../assets/Android.svg";
import SEGAIcon from "../assets/SEGA.svg";
import WebIcon from "../assets/Web.svg";
import AppleMacintoshIcon from "../assets/Apple-Macintosh.svg";
import CommodoreAmigaIcon from "../assets/Commodore-Amiga.svg";
import AtariIcon from "../assets/Atari.svg";

const platformIcons = {
  PC: PCIcon,
  PlayStation: PlayStationIcon,
  Xbox: XboxIcon,
  Nintendo: NintendoIcon,
  iOS: iOSIcon,
  Linux: LinuxIcon,
  Android: AndroidIcon,
  SEGA: SEGAIcon,
  Web: WebIcon,
  "Apple Macintosh": AppleMacintoshIcon,
  "Commodore / Amiga": CommodoreAmigaIcon,
  "Atari": AtariIcon
};

export default platformIcons;
